'use client';

import { useTranslation } from 'react-i18next';
import { Group, Text } from '@mantine/core';
import { getCountryFlagEmoji, getHolidayCountryLabel } from '@/utils/holidayDisplay';

export function HolidayCountryLabel({ country }: { country: string | null }) {
  const { t, i18n } = useTranslation();
  const flag = getCountryFlagEmoji(country);
  const label = getHolidayCountryLabel(country, i18n.language, t);

  return (
    <Group gap={6} wrap="nowrap">
      {flag !== null && (
        <Text size="sm" component="span" aria-hidden lh={1.2}>
          {flag}
        </Text>
      )}
      <Text size="sm" c="dimmed" component="span">
        {label}
      </Text>
    </Group>
  );
}
